<script setup>
import { ref, onMounted } from 'vue'
import panzoom from 'panzoom'

const container = ref(null)
const img = ref(null)
const isTouch = ('ontouchstart' in window || navigator.maxTouchPoints > 0)
let panZoomInstance

const props = defineProps({
    imgPath: {
        type: String,
        default: undefined,
    },
    altText: {
        type: String,
        default: undefined,
    },
});

onMounted(() => {
    panZoomInstance = panzoom(
        img.value, {
            smoothScroll: true,
            minZoom: 0.5,
            bounds: true,
            boundsPadding: 0.25,
            initialZoom: 1.1,
        });
})

function zoomIn() {
    panZoomInstance.zoomTo(0,0,1.2);
}

function zoomOut() {
    panZoomInstance.zoomTo(0,0,0.8);
}
</script>
<template>
    <div ref="container" class="max-h-full max-w-full image-container overflow-hidden">
        <img ref="img" :src="imgPath" :alt="altText" class="w-full h-auto zoomable-image">
    </div>

    <div v-if="!isTouch" class="absolute top-16 right-4 flex flex-col space-y-2">
        <button class="z-10 w-fit h-fit text-xl bg-white/50 hover:bg-platform-orange-light hover:text-platform-orange-dark transition-all rounded-lg p-2 flex items-center justify-center shadow-md cursor-pointer" @click="zoomIn">
            <font-awesome-icon fixed-width icon="fa-light fa-magnifying-glass-plus" />
        </button>
        <button class="z-10 w-fit h-fit text-xl bg-white/50 hover:bg-platform-orange-light hover:text-platform-orange-dark transition-all rounded-lg p-2 flex items-center justify-center shadow-md cursor-pointer" @click="zoomOut">
            <font-awesome-icon fixed-width icon="fa-light fa-magnifying-glass-minus" />
        </button>
    </div>
</template>
<style scoped>
    .zoomable-image {
        display: block;
        user-select: none;
    }
</style>